module.exports = __webpack_public_path__ + "static/media/arrow-line-right.4b29d2c3.svg";